import { DebugFlag } from '@content-platform/web-angular-shared-util-development';

export enum AuthDebugFlagNames {
  Impersonate = 'impersonate_user',
  Auto_Logout_Timeout = 'auto_logout_timeout'
}

export const AuthDebugFlags: DebugFlag[] = [
  {
    name: AuthDebugFlagNames.Impersonate,
    hasMetadata: true,
    metadataHint: 'UUID of user to impersonate',
    inputType: 'auto-complete'
  },
  {
    name: AuthDebugFlagNames.Auto_Logout_Timeout,
    hasMetadata: true,
    metadataHint: 'Enter the time in ms'
  }
];
